import { render, staticRenderFns } from "./WebIframe.vue?vue&type=template&id=1cc31a0a&scoped=true"
import script from "./WebIframe.vue?vue&type=script&lang=js"
export * from "./WebIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc31a0a",
  null
  
)

export default component.exports